import { Set } from '@everyboard/lib';
import { Coord } from '../../jscaip/Coord';
import { PlayerNumberMap } from '../../jscaip/PlayerMap';
import { PlayerOrNoneGameStateWithTable } from '../../jscaip/state/PlayerOrNoneGameStateWithTable';
export class ConspirateursState extends PlayerOrNoneGameStateWithTable {
    static WIDTH = 17;
    static HEIGHT = 17;
    static CENTRAL_ZONE_TOP_LEFT = new Coord(4, 6);
    static CENTRAL_ZONE_BOTTOM_RIGHT = new Coord(12, 10);
    static SHELTERS_INDICES = [0, 1, 3, 5, 7, 8, 9, 11, 13, 15, 16];
    static ALL_SHELTERS = new Set(ConspirateursState.SHELTERS_INDICES.flatMap((xOrY) => [
        new Coord(xOrY, 0),
        new Coord(xOrY, ConspirateursState.HEIGHT - 1),
        new Coord(0, xOrY),
        new Coord(ConspirateursState.WIDTH - 1, xOrY),
    ])).toList();
    isShelter(coord) {
        if (this.isVerticalEdge(coord)) {
            return ConspirateursState.SHELTERS_INDICES.some((y) => coord.y === y);
        }
        else if (this.isHorizontalEdge(coord)) {
            return ConspirateursState.SHELTERS_INDICES.some((x) => coord.x === x);
        }
        else {
            return false;
        }
    }
    isCentralZone(coord) {
        return ConspirateursState.CENTRAL_ZONE_TOP_LEFT.x <= coord.x &&
            coord.x <= ConspirateursState.CENTRAL_ZONE_BOTTOM_RIGHT.x &&
            ConspirateursState.CENTRAL_ZONE_TOP_LEFT.y <= coord.y &&
            coord.y <= ConspirateursState.CENTRAL_ZONE_BOTTOM_RIGHT.y;
    }
    isDropPhase() {
        return this.turn < 40;
    }
    getSidePieces() {
        if (this.turn % 2 === 0) {
            return PlayerNumberMap.of(20 - (this.turn / 2), 20 - (this.turn / 2));
        }
        else {
            // Player 0 plays on even turn, so has one less piece on odd turns
            return PlayerNumberMap.of(20 - ((this.turn - 1) / 2) - 1, 20 - ((this.turn - 1) / 2));
        }
    }
}
